import { render, staticRenderFns } from "./AddWithAIButton.vue?vue&type=template&id=60224d4a&scoped=true"
import script from "./AddWithAIButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddWithAIButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddWithAIButton.vue?vue&type=style&index=0&id=60224d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60224d4a",
  null
  
)

export default component.exports